import { DevTools } from 'jotai-devtools'
import css from 'jotai-devtools/styles.css?inline'
import React from 'react'

const DEVTOOLS_QUERY_KEY = '__jotaiDevtools'
const DEVTOOLS_STORAGE_KEY = '__LIGHTHOUSE_JOTAI_DEVTOOLS__'

function shouldEnableJotaiDevTools() {
    if (process.env.NODE_ENV === 'production') {
        return false
    }
    if (typeof window === 'undefined') {
        return false
    }

    const queryValue = new URLSearchParams(window.location.search).get(DEVTOOLS_QUERY_KEY)
    if (queryValue === '1' || queryValue === 'true') {
        return true
    }

    try {
        return window.localStorage.getItem(DEVTOOLS_STORAGE_KEY) === '1'
    } catch {
        return false
    }
}

export const JotaiDevTools = () => {
    return shouldEnableJotaiDevTools() ? (
        <>
            <style>{css}</style>
            <DevTools />
        </>
    ) : null
}
